import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { TherapistStateService } from '@therapist/shared/services/state/therapist-state.service';

/** Leitet gesperrte Therapeuten auf die Abo-Seite; ohne geladenen Therapeuten entscheidet der Auth-Guard. */
export const therapistSubscriptionCanMatch: CanMatchFn = () => {
  const therapistState = inject(TherapistStateService);
  return therapistState.isLocked() ? inject(Router).createUrlTree(['/subscription']) : true;
};
